import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/userprofile/successImg.png";
import { axiosInstance_user } from "../../axiosInstance-user";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
export function EducationDetails() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const userId = location.state?.id;
  console.log("userId", userId);

  const [occupation, setOccupation] = useState([]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const formik = useFormik({
    initialValues: {
      education: "",
      college: "",
      employed_in: "",
      occupation: "",
      organization: "",
      experience: "",
      annual_income: "",
      social_media: [],
    },
    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        setLoading(true);
        console.log("EditUser", values);

        const formData = new FormData();

        formData.append("profile[education]", Number(values.education));
        formData.append("profile[college]", values.college || "");
        formData.append("profile[occupation]", Number(values.occupation));
        formData.append("profile[organization]", values.organization || "");
        formData.append("profile[experience]", values.experience || 0);
        // formData.append("profile[annual_income]", values.annual_income || 0);
        formData.append("profile[annual_income]", Number(values.annual_income) || 0);

        // Define socialMediaArray before using it
        const socialMediaArray = Array.isArray(values.social_media)
          ? values.social_media
          : String(values.social_media)
              .split(",")
              .map((item) => item.trim())
              .filter((item) => item !== "");

        formData.append(
          "profile[social_media]",
          JSON.stringify(socialMediaArray)
        );

        const response = await axiosInstance_user.patch(
          `/users-profiles/${userId}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.status === "success") {
          setLoading(false); // Stop loader
          handleOpen();
          setTimeout(() => {
            handleClose();
          }, 2000);
          LoadUserProfile(userId);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "");
        console.error("Error while updating", error);
      } finally {
        setLoading(false);
      }
    },
  });
  // get user data
  async function LoadUserProfile(userId) {
    try {
      const response = await axiosInstance_user.get(
        `/users-profiles/${userId}`
      );
      if (response.data.status === "success") {
        // getting few fields from user and few from profile
        const user = response.data.data;
        const profile = user.profile || {};

        formik.setValues({
          education: profile.education || "",
          college: profile.college || "",
          employed_in: profile.employed_in || "",
          occupation: profile.occupation || "",
          // organization: profile.organization || "",
          organization:
            profile.organization?.toUpperCase() === "N/A"
              ? "N/A"
              : profile.organization || "",
          experience: profile.experience || "",
          // annual_income: profile.annual_income || "",
          annual_income:
            profile.annual_income !== undefined &&
            profile.annual_income !== null
              ? Number(profile.annual_income) // ensures 0.0 becomes 0
              : "",
          social_media: profile.social_media || [],
          password: "nathicharami", // required field
        });
      }
    } catch (err) {
      console.error("Failed to load profile:", err);
    }
  }
  useEffect(() => {
    if (userId) {
      LoadUserProfile(userId);
    }
  }, [userId]);
  async function LoadOccupation() {
    try {
      const response = await axiosInstance_user.get("/dropdown/occupation");

      if (response.status === 200 && response.data) {
        console.log("occupation", response.data);
        setOccupation(response.data);
      } else {
        console.error("Unexpected response format or status", response);
      }
    } catch (error) {
      console.error("Failed to load religion data:", error.message);
    }
  }
  useEffect(() => {
    LoadOccupation();
  }, []);

  return (
    <form onSubmit={formik.handleSubmit}>
      {loading && (
        <div className="loader-overlay">
          <CircularProgress style={{ color: "#f24464" }} />
        </div>
      )}
      <div>
        {/* Row 1 */}
        <div className="education-subcontainer">
          <div>
            <div className="education-label">Education</div>
            <div className="education-input">
              <select
                name="education"
                id="education"
                value={formik.values.education}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.education && formik.errors.education
                    ? "error"
                    : ""
                }`}
              >
                <option value="" disabled selected>
                  Select Education
                </option>
                <option value="1">Pre-Primary Education</option>
                <option value="2">Primary Education</option>
                <option value="3">Secondary Education</option>
                <option value="4">Graduate Degrees</option>
                <option value="5">Master's Degree</option>
                <option value="6">Doctorate (PhD)</option>
                <option value="7">Professional Doctorates</option>
                <option value="8">Vocational Courses</option>
                <option value="9">Non-Graduate</option>
              </select>
              {formik.touched.education && formik.errors.education && (
                <div className="text-danger">{formik.errors.education}</div>
              )}
            </div>
          </div>
          <div>
            <div className="education-label">College</div>
            <div className="education-input">
              <input
                type="text"
                name="college"
                placeholder="Enter College Name"
                value={formik.values.college}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.college && formik.errors.college && (
                <div className="text-danger">{formik.errors.college}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="education-subcontainer">
          {/* <div>
            <div className="education-label">Employed In <span className="text-danger">*</span></div>
            <div className="education-input">
              <input
                type="text"
                name="employed_in"
                placeholder="Enter Employed In"
                value={formik.values.employed_in}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.employed_in && formik.errors.employed_in && (
                <div className="text-danger">{formik.errors.employed_in}</div>
              )}
            </div>
          </div> */}

          <div>
            <div className="education-label">Occupation</div>
            <div className="education-input">
              <select
                name="occupation"
                id="occupation"
                value={formik.values.occupation}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  formik.setFieldValue("occupation", selectedId);
                  // find selected occupation
                  const selectedOccupation = occupation.find(
                    (item) => item.id == selectedId
                  );

                  if (
                    selectedOccupation &&
                    selectedOccupation.name === "Not working"
                  ) {
                    // auto-fill fields when not working
                    formik.setFieldValue("annual_income", "0");
                    formik.setFieldValue("organization", "N/A");
                  } else {
                    // reset for other occupations
                    formik.setFieldValue("annual_income", "");
                    formik.setFieldValue("organization", "");
                  }
                }}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.religion && formik.errors.religion
                    ? "error"
                    : ""
                }`}
              >
                <option value="" disabled>
                  Select Occupation
                </option>
                {occupation.map((list) => (
                  <option value={list.id} key={list.id}>
                    {list.name}
                  </option>
                ))}
              </select>
              {formik.touched.occupation && formik.errors.occupation && (
                <div className="text-danger">{formik.errors.occupation}</div>
              )}
            </div>
          </div>

          <div>
            <div className="education-label">Annual Income</div>
            <div className="education-input">
              <input
                type="number"
                min="0"
                name="annual_income"
                placeholder="Enter Annual Income"
                value={
                  formik.values.annual_income !== undefined &&
                  formik.values.annual_income !== null
                    ? formik.values.annual_income
                    : ""
                }
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
               disabled={Number(formik.values.annual_income) === 0}

              />
              {formik.touched.annual_income && formik.errors.annual_income && (
                <div className="text-danger">{formik.errors.annual_income}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 3 */}
        <div className="education-subcontainer">
          <div>
            <div className="education-label">Organization</div>
            <div className="education-input">
              <input
                type="text"
                name="organization"
                placeholder="Enter Organization"
                value={formik.values.organization}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={formik.values.organization?.toUpperCase() === "N/A"}

              />
              {formik.touched.organization && formik.errors.organization && (
                <div className="text-danger">{formik.errors.organization}</div>
              )}
            </div>
          </div>
          <div>
            <div className="education-label">Experience</div>
            <div className="education-input">
              <input
                type="number"
                name="experience"
                min="0"
                placeholder="Enter Experience"
                value={formik.values.experience}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.experience && formik.errors.experience && (
                <div className="text-danger">{formik.errors.experience}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 4 */}
        <div className="education-subcontainer">
          <div>
            <div className="education-label">Social Media</div>
            <div className="education-input">
              <input
                type="text"
                name="social_media"
                placeholder="Social media"
                value={formik.values.social_media}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.social_media && formik.errors.social_media && (
                <div className="text-danger">{formik.errors.social_media}</div>
              )}
            </div>
          </div>
        </div>

        {/* Modal & Button */}
        <div className="btnBasicSave">
          <Button type="submit">Save Changes</Button>
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          closeAfterTransition
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
        >
          <Fade in={open}>
            <Box sx={style} className="modal-box">
              <img src={successImg} alt="Success" />
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
              >
                Thank You
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              Education information has been successfully updated
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </form>
  );
}
